import { Link } from "gatsby";
import * as React from "react";
import { useEffect, useState } from "react";

const Debugger: React.FC = () => {
  if (process.env.GATSBY_ENV !== "development") return <></>;

  const [sizeScreen, setSizeScreen] = useState<[number, number]>([window.window.outerWidth, window.window.outerHeight]);
  const [hasScrollbarX, setHasScrollbarX] = useState<boolean>(document.body.scrollWidth > document.body.clientWidth);
  const [isViewDebugger, setIsViewDebugger] = useState<boolean>(true);
  function onResize() {
    setSizeScreen([window.window.outerWidth, window.window.outerHeight]);
    setHasScrollbarX(document.body.scrollWidth > document.body.clientWidth);
  }

  useEffect(() => {
    setSizeScreen([window.window.outerWidth, window.window.outerHeight]);
    setHasScrollbarX(document.body.scrollWidth > document.body.clientWidth);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <div
      className={`m-debugger 
      ${hasScrollbarX ? "m-debugger--danger" : ""}
      ${isViewDebugger ? "" : "m-debugger--hidden"}
      `}
    >
      <p className="debugger__medias">
        screen: {sizeScreen[0]} * {sizeScreen[1]}
        <br />
        {hasScrollbarX && <span>Tiene scroll lateral!</span>}
      </p>
      <button
        onClick={() => {
          setIsViewDebugger(false);
        }}
      >
        X
      </button>{" "}
      |
      <Link to={"/__testing-components/"} className="debugger__link">
        {" "}
        Ir a Testing{" "}
      </Link>
    </div>
  );
};

export default Debugger;
